import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'unauthorized',
  templateUrl: './unauthorized.component.html'  
})
export class UnauthorizedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
